// ADR-108/109: a paper document (invoice…) is shared as a PNG of what the screen shows. Phones (APK): the image is
// written to the cache and handed to the share sheet (WhatsApp…). Browsers with a file share sheet use it; other
// browsers save the image. Text is the last fallback. The image code loads only when "Share" is pressed.
import { Capacitor } from '@capacitor/core';

export type ShareResult = 'shared' | 'saved' | 'text';

export async function shareDocument(
  node: HTMLElement,
  name: string,
  title: string,
  text: string,
): Promise<ShareResult> {
  const { toPng } = await import('html-to-image');
  const background = getComputedStyle(node).backgroundColor;
  const dataUrl = await toPng(node, { pixelRatio: 2, backgroundColor: background, cacheBust: true });
  const file = `${name}.png`;

  if (Capacitor.isNativePlatform()) {
    const [{ Filesystem, Directory }, { Share }] = await Promise.all([
      import('@capacitor/filesystem'),
      import('@capacitor/share'),
    ]);
    const saved = await Filesystem.writeFile({
      path: file,
      data: dataUrl.slice(dataUrl.indexOf(',') + 1),
      directory: Directory.Cache,
    });
    await Share.share({ title, text, files: [saved.uri] });
    return 'shared';
  }

  const blob = await (await fetch(dataUrl)).blob();
  const png = new File([blob], file, { type: 'image/png' });
  if (navigator.canShare?.({ files: [png] })) {
    await navigator.share({ title, files: [png] });
    return 'shared';
  }
  const a = document.createElement('a');
  a.href = dataUrl;
  a.download = file;
  a.click();
  return 'saved';
}
